import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { selectRatingInfo } from 'shared/store/product/selector';
import { changeProductQuesAndRatingTab } from 'shared/store/product/action';
import { State } from 'shared/store/types';
import {
  RATING_POPUP_CLASS,
  REVIEW_QA_SECTION,
} from 'shared/constants/productPage';
import StarImage from './StarIcons/StarImage';
import RatingCountPopUp from './RatingCountPopUp';
import RatingAndReviewCount from './RatingAndReviewCount';

const Wrap = styled.div`
  padding: ${({ theme }) => theme.spacing.spacing40} 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  display: flex;
  align-items: center;
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-bottom: ${({ theme }) => theme.spacing.spacing60};
  }
`;

const RatingAndQueInfo = styled.div`
  margin-right: ${({ theme }) => theme.spacing.spacing40};
  padding-right: ${({ theme }) => theme.spacing.spacing40};
  // border-right: 1px solid ${({ theme }) =>
    hexToRgb(theme.colors.state, 0.12)};
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const StarRating = styled.div`
  margin-right: ${({ theme }) => theme.spacing.spacing40};
  padding-right: ${({ theme }) => theme.spacing.spacing40};
  border-right: 1px solid ${({ theme }) => hexToRgb(theme.colors.state, 0.12)};
  display: flex;
  cursor: pointer;
  align-items: center;
  &:hover {
    .${RATING_POPUP_CLASS} {
      visibility: visible;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    ${({ theme }) => theme.typography.bodyMedium};
    margin-right: 10px;
    padding-right: 10px;
  }
`;

const RatingCount = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  line-height: unset;
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  span {
    ${({ theme }) => theme.typography.bodyMedium};
  }
`;

const RatingWrapper = styled.span``;

// const QueCount = styled.div`
//   ${({ theme }) => theme.typography.subTitleMedium};
//   margin-right: ${({ theme }) => theme.spacing.spacing40};
//   padding-right: ${({ theme }) => theme.spacing.spacing40};
//   margin-bottom: ${({ theme }) => theme.spacing.spacing20};
//   cursor: pointer;
// `;

const Rating = () => {
  const dispatch = useDispatch();
  const ratingInfo = useSelector((state: State) => selectRatingInfo(state));
  const {
    rating,
    reviewCount = 0,
    ratingCount = 0,
    // qnaCount = 0,
    reviewSplitUp,
  } = ratingInfo || {};
  const handleClick = (scrollTo: string, activeTab: number) => {
    const ratingNode = document?.getElementById(scrollTo);
    if (ratingNode) {
      ratingNode.scrollIntoView({ behavior: 'smooth' });
    }
    dispatch(changeProductQuesAndRatingTab(activeTab));
  };
  return (
    <Wrap>
      {rating && rating > 0 && (
        <StarRating onClick={() => handleClick(REVIEW_QA_SECTION, 0)}>
          <RatingWrapper aria-label={`${rating} out of 5 stars`}>
            <StarImage ratingCount={Math.floor(rating)} />
          </RatingWrapper>
          <RatingCount aria-hidden="true">
            {rating}
            <span>/5</span>
          </RatingCount>
          <RatingCountPopUp
            reviewSplitUp={reviewSplitUp}
            rating={rating}
          />
        </StarRating>
      )}
      {(reviewCount > 0 || ratingCount > 0) && (
        <RatingAndQueInfo onClick={() => handleClick(REVIEW_QA_SECTION, 0)}>
          <RatingAndReviewCount
            reviewCount={Number(reviewCount)}
            ratingCount={Number(ratingCount)}
          />
        </RatingAndQueInfo>
      )}
      {/* <QueCount
        onClick={() => handleClick(REVIEW_QA_SECTION, 1)}
      >
        {(qnaCount > 0)
        && qnaCount}
        &nbsp;Q&As
      </QueCount> */}
    </Wrap>
  );
};

export default Rating;
